export default {
  getTotalUserDownload() {
    const data = require('./__mocks__/totalUser.json')
    return data
  },
}